<template>
    <div class="rr-box">
        <ReumTextBox class="input-text rr-text" label="Sample Script" v-model="comp.info.text"></ReumTextBox>
        <button v-if="comp.info.status==0" class="btn-rec" @click="comp.onRecord"><i class="las la-microphone"></i></button>
        <button v-if="comp.info.status==1" class="btn-rec">...</button>
        <button v-if="comp.info.status==2" class="btn-rec" @click="comp.onStop"><i class="las la-stop"></i></button>
        <audio id="audioplayer" class="rr-voice" :src="comp.info.mergeURL" controls></audio>
        <button class="btn-audio" @click="comp.onPlay('')" :class="{ 'active':comp.info.mergeURL!=null }"><i class="las la-play"></i></button>
        <button v-if="comp.info.mergeURL!=null" class="btn-send" @click="comp.onSend"><i class="lar la-paper-plane"></i> Send to Server</button>
    </div>
    <div class="bar"><span>uploaded list</span></div>
    <div class="sample-list">
        <template v-for="(irow, i) in comp.list" :key="i">
            <div class="sample-item">
                <div><span>{{ irow.script }}</span></div>
                <button class="btn-play" @click="comp.onPlay(irow)" :class="{ 'play':comp.play.idx==irow.idx }"><i class="las la-play"></i></button>
                <button type="button" class="btn-del" @click="comp.doDelete(irow.idx)"><i class="lar la-trash-alt"></i></button>
            </div>
        </template>
    </div>
    <audio id="audioplayer2" class="rr-voice" :src="comp.play.vpath"></audio>
    <div class="bar"></div>
    <div>
        <!-- <router-link class="btn" to="/Scripts/List">View List</router-link> -->
    </div>
</template>

<script>
import { reactive, onMounted, ref } from "vue";
import axios from "axios";
import { useToast } from 'vue-toastification';
import ReumTextBox from "@/components/ReumLib/UI/ReumTextBox.vue";

export default {
    name: "Scripts",
    props: {
        modelValue: String,
    },
    components: {
        ReumTextBox
    },
    setup(props) {
        const editor = ref(null);
        const toast  = useToast();
        const comp = reactive({
            audioplayer : null,
            info: {
                text:"",
                status: 0,
                chunks: [],
                mergeURL: null,
                source:null,
                base64: null,
            },
            rec_config: {
                audio: true,
                // {
                //     channelCount: 1,
                //     sampleRate: 16000,
                //     sampleSize: 16,
                //     volume: 1
                // },
                video:false
            },
            recorder : null,
            list:[], total:0,
            play: { idx:0, vpath:"" },

            gotStream: (mediaStream) => {
                console.info("gotStream");
                comp.info.status = 2;
                window.streamReference = mediaStream;
                comp.recorder = null;
                comp.recorder = new MediaRecorder(mediaStream);
                comp.recorder.start(100);
                comp.recorder.ondataavailable = comp.audioDataHandler;
            },
            onRecord: () => {
                console.info("Record");
                comp.info.status = 1;
                comp.info.chunks = [];
                navigator.mediaDevices.getUserMedia(comp.rec_config)
                .then(comp.gotStream)
                .catch(err => {
                    console.error(err.name + ": " + err.message)
                    toast.error(err.name + ": " + err.message)
                    comp.info.status = 0;
                });
            },
            onStop: () => {
                console.info("Stop");
                comp.info.status = 3;
                if (!window.streamReference) {
                    return;
                }
                window.streamReference.getAudioTracks().forEach(track => {
                    track.stop();
                });
                window.streamReference = null;

            },
            onSend: () => {
                let params = {
                    text:comp.info.text,
                    raw:comp.info.base64
                }
                if( !params.text ){
                    toast.warning("스크립트를 입력하세요.")
                    return
                }
                axios.post("/ai/sample_upload", params).then((res) => {
                    if(res.data.err == 0) {
                        comp.info.text = ""
                        comp.info.base64 = null
                        comp.info.mergeURL = null
                        toast.success("전송했습니다.");
                        comp.doSearch()
                    } else {
                        if( res.data.err_msg ) toast.error(res.data.err_msg);
                    }
                }).catch((err) => {
                    toast.error("연결에 오류가 있습니다. :: ", err);
                });
            },
            audioDataHandler(event){
                console.info("Push");
                comp.info.chunks.push(event.data);
                if(comp.info.status == 3) {
                    let mergeBlob = new Blob(comp.info.chunks,{type:'audio/wav; codecs=MS_PCM'})
                    comp.info.mergeURL = URL.createObjectURL(mergeBlob);

                    let reader = new FileReader();
                    reader.onload = function(event){
                        comp.info.base64 = event.target.result;
                    }; // data url!
                    comp.info.source = reader.readAsDataURL(mergeBlob);
                    comp.info.status = 0;
                }
            },
            onPlay:(o) => {
                // comp.audioplayer.volume = 0.2;
                // comp.audioplayer.loop = true;
                if( o ){
                    comp.play.idx = o.idx
                    comp.play.vpath = o.vpath
                    let audioplayer = document.getElementById("audioplayer2")
                    setTimeout(() =>{
                        audioplayer.play();
                    }, 200)
                    
                } else {
                    comp.play.idx = 0
                    comp.play.vpath = ""
                    comp.audioplayer.play();
                }
            },

            doSearch: () => {
                let params = {
                    page : comp.page
                }
                axios.get("/ai/sample_list", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.list = res.data.list
                        comp.total = res.data.total
                    }
                })
            },

            doDelete:(idx)=>{
                let params = { idx:idx }
                if( confirm("삭제하시겠습니까?") == true ){
                    axios.get("/ai/sample_del", { params:params }).then((res) => {
                        if( res.data.err == 0 ){
                            comp.doSearch()
                        } else {
                            if( res.data.err_msg ) toast.error( res.data.err_msg )
                        }
                    })
                }
            }

        });
        onMounted(() => {
            comp.val = props.text;

            comp.audioplayer = document.getElementById("audioplayer")

            comp.doSearch()
        });
        return { comp, editor, props };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";

    .rr-box {
        padding:10px 20px;

        .rr-text {
            width:calc(100% - 90px); float:left;
        }
        .rr-voice {
            width:1px; height:1px; opacity:0.01;
        }
        .btn-rec {
            width:40px; height:40px; padding: 3px 0px;color: #FFF; margin-top:10px;
            background-color: rgb(238, 122, 122); border: 1px solid #ddd; border-radius: 50%; font-size:1.4rem; text-align:center;
        }
        .btn-audio {
            width:40px; height:40px; padding: 3px 10px;color: #FFF; margin-top:10px;
            background-color:#d0d0d0; border: 1px solid #ddd; border-radius: 50%;
            font-size:1.4rem; text-align:center;
            &.active {
                background-color:rgba(177, 214, 129, 0.7);
            }
        }
        .btn-send {
            width:100%; height:40px; padding: 3px 10px; margin-top:5px;
            background-color: rgb(122, 134, 238); color: #FFF;
            border: 1px solid #ddd; border-radius: 50px;
        }
    }
    .bar {
        position:relative; height:20px; padding:10px 0px; border-top:1px solid #c8c8c8; margin:20px 20px 0;
        span {
            position:absolute; top:-10px; left:0; right:0; width:90px; margin:0 auto; text-align:center; background-color:#f9f9f9; color:#999;
        }
    }

    .sample-list {
        padding:0 20px;
        .sample-item {
            position:relative; margin-bottom:5px; border-bottom:1px solid #c8c8c8; padding-bottom:5px;
            > div {
                position:relative;
                width:calc(100% - 100px); height:40px; text-align:left; vertical-align:middle;
                display:flex;justify-content: center; align-items: center;
                span {
                    position:absolute; left:0; vertical-align:middle;
                }
            }
            .btn-play {
                position:absolute; top:0; right:50px;
                width:40px; height:40px; padding: 3px 10px;color: #FFF;
                background-color:rgba(177, 214, 129, 0.7); border: 1px solid #ddd; border-radius: 50%;
                font-size:1.4rem; text-align:center;
            }
            .btn-del {
                position:absolute; top:0; right:0px;
                width:40px; height:40px; padding: 3px 0px;
                background-color: rgb(255, 81, 81); color: #FFF;
                border: 1px solid #ddd; border-radius: 50px; font-size:1.4rem; text-align:center;
            }
        }
    }

</style>